import { createAction } from '@reduxjs/toolkit';

const FETCHING_ROLE_LIST = 'FETCHING_ROLE_LIST';
const FETCHING_ROLE_LIST_SUCCESS = 'FETCHING_ROLE_LIST_SUCCESS';
const FETCHING_ROLE_LIST_FAILURE = 'FETCHING_ROLE_LIST_FAILURE';
const CREATE_ROLE = 'CREATE_ROLE';
const GET_ROLE_DETAIL = 'GET_ROLE_DETAIL';
const UPDATE_ROLE = 'UPDATE_ROLE';
const CLEAR_ROLE = 'CLEAR_ROLE';
const ROLE_FETCHING_GROUP_PERMISSIONS_LIST = 'FETCHING_GROUP_PERMISSIONS_LIST';
const ROLE_FETCHING_PERMISSIONS_LIST = 'FETCHING_PERMISSIONS_LIST';

export interface GroupPermissions {
    id: number;
    name: string;
    code: string;
}

export interface Permissions {
    id: number;
    name: string;
    codename: string;
}

export const ROLE_TYPE_SYSTEM = 1;
export const ROLE_TYPE_CUSTOM = 2;
export type RoleType = typeof ROLE_TYPE_SYSTEM | typeof ROLE_TYPE_CUSTOM;

export interface roleListSuccessPayload {
    id?: number | string;
    name: string;
    code: string;
    status: 0 | 1;
    description?: string;
    /** 1 vai trò hệ thống (không được xóa), 2 vai trò tùy chỉnh (được xóa) */
    type?: RoleType;
    group_permissions: GroupPermissions[];
    permissions: Permissions[];
    created_at: string;
    updated_at: string;
}

type roleDataDetailType = Omit<
    roleListSuccessPayload,
    'id' | 'status' | 'created_at' | 'updated_at' | 'code'
>;

export const fetchingRoleList = createAction(FETCHING_ROLE_LIST, (filters: any) => ({
    payload: filters,
}));

export const fetchingRoleListSuccess = createAction<
    roleListSuccessPayload[]
>(FETCHING_ROLE_LIST_SUCCESS);

export const fetchingRoleListFailure = createAction(
    FETCHING_ROLE_LIST_FAILURE,
);

export const createRole = createAction<roleDataDetailType>(CREATE_ROLE);

export const getRoleDetail = createAction(
    GET_ROLE_DETAIL,
    (id: string) => ({
        payload: { id: id },
    }),
);

export const clearRole = createAction(CLEAR_ROLE);

export const updateRole = createAction<any>(
    UPDATE_ROLE,
    (data: roleDataDetailType, id: string) => ({
        payload: { data: data, id: id },
    }),
);

export const fetchGroupPermissionsList = createAction(ROLE_FETCHING_GROUP_PERMISSIONS_LIST, (page: number | null, page_size: number | null, status: number | null) => ({
    payload: { page: page, page_size: page_size, status: status }
}));
export const fetchPermissionsList = createAction(ROLE_FETCHING_PERMISSIONS_LIST, (page: number | null, page_size: number | null) => ({
    payload: { page: page, page_size: page_size }
}));
